module.exports = __webpack_public_path__ + "fk.f202e72c782f6cefea02.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/fk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/fk.svg
// module chunks = styles